import styledComp from 'styled-components';
import {
  FormControl, Paper, Checkbox,
} from '@mui/material';
import { DatePickerProps, DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import { Styling } from '../../../../constants';

export const ProgressContainer = styledComp.div`
  height: 4px;
`;

export const SelectedContainer = styledComp(Paper)`
  display: flex;
  margin: 10px;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px;
`;

export const VendorName = styledComp.span`
  margin-left: 10px;
`;

export const QualifierSelect = styledComp(FormControl)`
  width: 100%;
`;

export const TextFilterContainer = styledComp.div`
  padding: 0 ${Styling.DEFAULT_SPACING}px;
`;

export const VendorOptionsContainer = styledComp.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DatePicker = styledComp(MuiDatePicker) <DatePickerProps<Date>>`
  margin-top: 10px !important;
  .MuiInputBase-root {
    min-height: 50px;
  }
  .MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputAdornedEnd {
    font-size: 15px;
  }
`;

export const VendorsContainer = styledComp.div`
  overflow-y: auto;
`;
